(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artie-review-rotator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-artie-review-rotator]').forEach(function (root) {
  var slides = root.querySelectorAll('[data-artie-review-slide]');
  var dots = root.querySelectorAll('[data-artie-review-dot]');
  if (slides.length < 2) return;
  var index = 0;
  var intervalMs = (parseInt(root.dataset.interval, 10) || 7) * 1000;
  var timer = null;

  function show(next) {
    slides[index].classList.remove('is-active');
    if (dots[index]) dots[index].classList.remove('is-active');
    index = (next + slides.length) % slides.length;
    slides[index].classList.add('is-active');
    if (dots[index]) dots[index].classList.add('is-active');
  }
  function start() {
    stop();
    timer = setInterval(function () { show(index + 1); }, intervalMs);
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      show(i);
      start();
    });
  });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  start();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
